import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const ResetPasswordSuccess = ({ dark }) => {
  const navigate = useNavigate();
  const [count, setCount] = useState(5);

  useEffect(() => {
    if (count <= 0) { navigate('/signin', { replace: true }); return; }
    const timer = setTimeout(() => setCount(c => c - 1), 1000);
    return () => clearTimeout(timer);
  }, [count, navigate]);

  return (
    <div className="text-center">
      <div className="inline-flex items-center justify-center w-14 h-14 rounded-full mb-5" style={dark ? { background: 'rgba(52,211,153,0.15)' } : { background: '#f0fdf4' }}>
        <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24" style={dark ? { color: 'rgba(110,231,183,0.9)' } : { color: '#16a34a' }}>
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
      </div>

      <h1 className="text-2xl font-semibold mb-2" style={dark ? { color: 'rgba(255,255,255,0.95)' } : { color: '#111827' }}>Password updated!</h1>
      <p className="text-sm mb-1" style={dark ? { color: 'rgba(255,255,255,0.5)' } : { color: '#6b7280' }}>Your password has been successfully reset.</p>
      <p className="text-sm mb-8" style={dark ? { color: 'rgba(255,255,255,0.35)' } : { color: '#9ca3af' }}>
        Redirecting to sign in in{' '}
        <span className="font-semibold tabular-nums" style={dark ? { color: 'rgba(255,255,255,0.7)' } : { color: '#374151' }}>{count}</span>
        {count === 1 ? ' second' : ' seconds'}…
      </p>

      <button
        onClick={() => navigate("/signin", { replace: true })}
        className={`w-full py-2.5 px-4 text-white text-sm font-semibold rounded-xl shadow-sm ${dark ? 'auth-btn-primary' : 'bg-blue-600 hover:bg-blue-700 transition-colors duration-150'}`}
      >
        Continue to sign in
      </button>
    </div>
  );
};

export default ResetPasswordSuccess;
